import { Pipe, PipeTransform } from '@angular/core';
import { environment } from '@environments/environment';

@Pipe({ name: 'fullUrl' })
export class FullUrlPipe implements PipeTransform {
  transform(value: any): any {
    if (value && typeof value === 'string') {
      return `${environment.apiBaseUrl}${value}`;
    } else if (value && value.url) {
      return `${environment.apiBaseUrl}${value.url}`;
    }

    return null;
  }
}
